/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
import { Polymer, html } from '@polymer/polymer/polymer-legacy.js';
//import './corp/corporate-payable-receivables.js';
//import './corp/corporate-approvals.js';
//import './corp/corporate-financial-schedule.js';
//import './corp/corporate-forex.js';
//import './corp/corporate-notes.js';
//import './corp/corporate-graph.js';
//import './../../crp_account_ui/elements/corporate-cash-management.js';
//import './corp/hybrid-corporate-approval-myinbox-widget.js';
//import './corp/hybrid-corporate-accounts-widget.js';
//import '../../corporate_common_ui/elements/nbb-dashboard.js';
const template = html`
    <style include="app-styles">
    .fixed-height{
      height: auto;
    }
    </style>
<app-media-query phone="{{phone}}" desktop="{{desktop}}" tablet="{{tablet}}" notsupporteddevice={{notsupporteddevice}}></app-media-query>
<page-title name="h_CorporateDashboard" left-action="{{leftAction}}"></page-title>

<nbb-dashboard></nbb-dashboard>
	<!--<div class="mdl-grid mdl-grid-no-spacing">
		<template is="dom-if" if="{{!phone}}" restamp="true">	
    <paper-card class="mdl-cell mdl-cell--4-col-phone mdl-cell--4-col-tablet mdl-cell--8-col light-background">
      <corporate-financial-schedule payableslist="{{payableslist}}" receivableslist="{{receivableslist}}"></corporate-financial-schedule>
    </paper-card>
			<paper-card class="mdl-cell mdl-cell--4-col-phone mdl-cell--4-col-tablet mdl-cell--4-col light-background">
				<div class="mdl-grid w-full border-box">
                    <div class="mdl-cell mdl-cell--4-col-phone mdl-cell--4-col-tablet mdl-cell--6-col center-center primary-dark-text-xl" style="margin-top: 8px;">
                        <oe-i18n-msg class="" style="margin-left: 14px; line-height: 30px;" msgid="h_pendingApprovals" id="corporate-notes-header"></oe-i18n-msg>
                    </div>
                </div>
                
                    <div id="corpDashboardApprovals" class="dashboard-paper-card-height dashboard-paper-card flex">
                        <corporate-approvals-landing selected={{selected}} approvals-list={{approvalsList}} initiated-list={{initiatedList}}></corporate-approvals-landing>
                      
                    </div>
                
                <div class="mdl-grid mdl-cell--12-col content-align-center border-t-1px full-width border-box" on-tap="_pendingApprovals" style="padding: 20px 0;">
                    <div class="primary-dark-font-m corp-text-brand-color cursor-pointer"><oe-i18n-msg msgid="h_ViewMore"></oe-i18n-msg></div>
                </div>
		</paper-card>

  </template>
  <template is="dom-if" if="{{phone}}" restamp="true">
  <paper-card class="mdl-cell mdl-cell--4-col-phone mdl-cell--4-col-tablet mdl-cell--4-col light-background fixed-height">
	<hybrid-corporate-accounts-widget currencywisebalance={{currencywisebalance}} account-group={{accountGroup}} spinnerflag={{spinnerflag}}
	 loanaccounts={{loanaccounts}} depositaccounts={{depositaccounts}} id="hybrid-cash-position-accounts-element" accounts-list={{accountsList}} totalcashposition={{totalcashposition}} all-currencies="{{allCurrencies}}" home-currency={{homeCurrency}} custom-accounts={{customAccounts}} total-current-amount={{totalCurrentAmount}} total-savings-amount={{totalSavingsAmount}} total-other-amount={{totalOtherAmount}} total-credit-amount={{totalCreditAmount}} total-loan-amount={{totalLoanAmount}} total-deposit-amount={{totalDepositAmount}} total-oper-amount={{totalOperAmount}} total-amount={{totalAmount}}> </hybrid-corporate-accounts-widget>
=           <div id="corporate_transaction_details_loader_main_div" hidden$={{!loaderActive}} class="light-background content-align-center">
          <div id="corporate_transaction_details_loader_sub_div1" class="mdl-grid mdl-grid--no-spacing light-background loaderWrapper">
            <div id="corporate_transaction_details_loader_sub_div2">
              <paper-spinner id="loaderSpinner" active tabindex="0" role="progressbar" aria-label="Loading"></paper-spinner>
            </div>
          </div>
        </div>  
  </paper-card>
   <paper-card class="mdl-cell mdl-cell--4-col-phone mdl-cell--4-col-tablet mdl-cell--4-col light-background fixed-height">
	
	<hybrid-corporate-approval-myinbox-widget></hybrid-corporate-approval-myinbox-widget>
	
  </paper-card> 
  </template>
</div>-->`;
Polymer({
    is: 'corporate-dashboard',
    _template: template,
    properties: {
        //payables 
        payableslist: {
            type: Array,
            notify: true,
            value: []
        },
        //receivables
        receivableslist: {
            type: Array,
            notify: true,
            value: []
        },
        //List of Ticker Messages and hyperlinks
        tickerMessageList: {
            type: Array,
            notify: true,
            value: []
        },
        //Flag For tickerMessage list availble or not
        tickerMessageListAvailable: {
            type: Boolean,
            notify: true,
            value: false
    },
	accountsList: {
      type: Array,
      notify: true,
      value: []
    },
	allCurrencies: {
      type: Array,
      notify: true
    },
    currencywisebalance: {
      type: Object,
      notify: true
    },
	homeCurrency: {
      type: String,
      notify: true
    },
    totalcashposition: {
      type: Number,
      notify: true,
      value: 0
    },
	phone: {
      type: Boolean,
      notify: true
    },
	loaderActive: {
		type: Boolean,
		value: true,
		notify: false
	},
	/*NEW properties */
	totalCurrentAmount: {
      type: Object,
      notify: true
    },
	totalSavingsAmount: {
      type: Object,
      notify: true
    },
	totalOtherAmount: {
      type: Object,
      notify: true
    },
	totalCreditAmount: {
      type: Object,
      notify: true
    },
	totalLoanAmount: {
      type: Object,
      notify: true
    },
	totalDepositAmount: {
      type: Object,
      notify: true
    },
	totalOperAmount: {
      type: Object,
      notify: true
    },
    loanaccounts: {
      type: Array,
      notify: true
    },
	depositaccounts: {
      type: Array,
      notify: true
    },
    spinnerflag: {
      type: Boolean,
      notify: true,
      value: true
    },
	customAccounts: {
      type: Object,
      notify: true
    },
	totalAmount: {
      type: Object,
      notify: true
    },
    screenWidth: {
      type: Number
    }
  },

  attached: function () {

  /*  
    var self = this;
    self.userId = clientStorage.get(storageType.session, 'userId');
	var operativeAccountsCall = document.createElement('oe-ajax');
    operativeAccountsCall.contentType = "application/json";
    operativeAccountsCall.handleAs = "json";
    operativeAccountsCall.url = "/api/CBUsers/" + clientStorage.get(storageType.session, 'userId') + "/customoperativeaccounts";
    operativeAccountsCall.method = 'get';
    oeAjaxEventListner(operativeAccountsCall);
    operativeAccountsCall.generateRequest();
    operativeAccountsCall.addEventListener('response', function (event) {
      clientStorage.set(storageType.session, 'operativeAccountList', event.detail.response);
    });
    /* Commented by Satya for removing recievables and transfer unncessary API calls

    var numberOfPayables = config.SpeedBoat.App.corporateDashboard.numberOfPayables;
    var numberOfReceivables = config.SpeedBoat.App.corporateDashboard.numberOfReceivables;
    var getPayables = document.createElement("oe-ajax");
    getPayables.contentType = "application/json";
    getPayables.handleAs = "json";
    var ajaxCall = document.createElement('oe-ajax');
    ajaxCall.contentType = "application/json";
    ajaxCall.handleAs = "json";
    ajaxCall.url = "/api/propertyreferences?filter[where][propertyName]=HOME_CUR_CODE";
    ajaxCall.method = 'get';
    oeAjaxEventListner(ajaxCall);
    ajaxCall.generateRequest();
    ajaxCall.addEventListener('response', function (event) {
      clientStorage.set(storageType.session, 'homeCurrency', event.detail.response[0].propertyValue);
      if (self.phone) {
        self._gethybridAccounts();
      }
      getPayables.url = "/api/CBUsers/" + self.userId + "/transfers?filter[where][transactionDateFrom]=" + setBusinessDateString(new Date()) + "&filter[where][transactionDateTo]=" + setBusinessDateString(self.getNextDate()) + "&filter[where][transactionCurrency.cmCode]=" + event.detail.response[0].propertyValue + "&filter[where][transactionStatus.cmCode]=SUC";
      if (!self.phone) {
        getPayables.generateRequest();
      }
      getPayables.addEventListener('response', function (event) {
        var response = event.detail.response;
        response.forEach(function (obj) {
          obj.pay = true;
        });
        response.sort(function (a, b) {
          return new Date(a.transactionDate) - new Date(b.transactionDate);
        });

        if (numberOfPayables > 0) {
          response.splice(numberOfPayables);
        }

        self.payableslist = response;
      });
    });

    var getReceivables = document.createElement("oe-ajax");
    getReceivables.contentType = "application/json";
    getReceivables.handleAs = "json";

    getReceivables.url = "/api/CBUsers/" + this.userId + "/receivables?filter[where][transactionDate][gt]=" + setBusinessDateString(new Date()) + "&filter[where][transactionDate][lt]" + setBusinessDateString(this.getNextDate());
    oeAjaxEventListner(getReceivables);
    if (!self.phone) {
      getReceivables.generateRequest();
    }
    getReceivables.addEventListener('response', function (event) {
      var response = event.detail.response;
      response.sort(function (a, b) {
        return new Date(a.transactionDate) - new Date(b.transactionDate);
      });

      if (numberOfReceivables > 0) {
        response.splice(numberOfReceivables);
      }

      self.receivableslist = response;
    });

    
    if (!self.phone) {
      this._getAjaxTickerMessageCorp();
    }
    
    Commented by Satya for removing recievables and transfer unncessary API calls */

  },
  //Parse standard Date format to accepted date format
  dateParse: function (d) {
    return d.toISOString().slice(0, 10);
  },
  getNextDate: function () {
    var todayDate = new Date();
    var d = todayDate.getDate();
    var m = todayDate.getMonth();
    var y = todayDate.getFullYear();
    return new Date(y, m, d + 30);
  },

  /*Get list from ticker messages service call */
  _getAjaxTickerMessageCorp: function () {
    var ajaxCall = document.createElement('oe-ajax');
    var self = this;
    ajaxCall.contentType = "application/json";
    ajaxCall.handleAs = "json";
    ajaxCall.url = "/api/corporates/" + clientStorage.get(storageType.session, 'corpId') + "/ticker-messages";
    ajaxCall.method = 'get';
    ajaxCall.addEventListener('response', function (event) {
      self.tickerMessageList = event.detail.response;
      self.tickerMessageListAvailable = true;
    });
    ajaxCall.addEventListener('error', function (err) {
      self.errorMessage = "";
      self.errorMessage = JSON.parse(err.detail.request.response.error.message.channelcontext).status.message[0].messageDesc;
    });
    ajaxCall.generateRequest();
  },
  
   _gethybridAccounts: function () {
	this.userId = clientStorage.get(storageType.session, "userId");
	this.homeCurrency = clientStorage.get(storageType.session, 'homeCurrency');
	var filters = {};
    var ajaxCall = document.createElement('oe-ajax');
    var self = this;
    ajaxCall.contentType = "application/json";
    ajaxCall.handleAs = "json";
    ajaxCall.url = "/api/CBUsers/" + self.userId + "/accounts";
    ajaxCall.method = 'get';
	ajaxCall.params.filter = JSON.stringify(filters);
    ajaxCall.addEventListener('response', function (event) {
		//self.fire('stop-processing-loader');
		self.loaderActive = false;
      self.accountsList = event.detail.response;
      //self.tickerMessageListAvailable = true;
    });
    ajaxCall.addEventListener('error', function (err) {
		self.loaderActive = false;
		//self.fire('stop-processing-loader');
      self.errorMessage = "";
      self.errorMessage = JSON.parse(err.detail.request.response.error.message.channelcontext).status.message[0].messageDesc;
    });
    ajaxCall.generateRequest();
  }
});
